import { render, staticRenderFns } from "./MenuPermissionsTab.vue?vue&type=template&id=644f9112&"
import script from "./MenuPermissionsTab.vue?vue&type=script&lang=ts&"
export * from "./MenuPermissionsTab.vue?vue&type=script&lang=ts&"
import style0 from "./MenuPermissionsTab.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VList,VRow,VSwitch,VTabItem})
